<div class="flex flex-col gap-4 min-w-96 bg-grey-200">
    <div class="flex flex-col page-padding-x page-padding-y bg-grey-200">
        <h3 id="title-certificate-of-appreciation">Certificate of Appreciation</h3>

        @if (projectDetails) {
            <h5 id="heading-designation" class="text-darkBlue-600">{{ projectDetails.designation }}</h5>
            <h5 id="heading-project-title">{{ projectDetails.projectTitle }}</h5>
        }
            
    </div>

    @if (isLoading) {
        <div class="flex items-center justify-center h-full">
          <app-loading-indicator [size]="32"></app-loading-indicator>
        </div>
    } @else {
        <div class="flex flex-col page-padding-x page-padding-b page-padding-y gap-4 bg-grey-100">
            @if (hasPermissionToViewCoaPage && !isExpired) {
                <form [formGroup]="coaForm">
                    <div class="flex flex-col ">
                        <h5 id="heading-certificate-of-appreciation-preference">Certificate of Appreciation Preference<span class="body-xlarge-bold text-red-500">&nbsp;*</span></h5>
                        <app-radio-group
                            name="radio-coa-preference"
                            [options]="coaPreferenceOptions"
                            [layoutDirection]="RadioButtonLayoutDirection.Vertical"
                            formControlName="certificatePreferenceCtrl"
                        ></app-radio-group>                    
                    </div>

                    <hr/>

                    <div class="flex flex-col gap-4 pt-4">
                        <h5 id="heading-shipping-details">Shipping Details</h5>
                        <div class="flex flex-col gap-4 md:flex-row">
                            <app-input
                                class="flex max-w-24"
                                id="input-title"
                                label="Title"
                                placeholder="Mr"
                                [isRequiredLabel]="true"
                                formControlName="salutationCtrl"
                            ></app-input>
                            <app-input
                                id="input-first-name"
                                label="First Name"
                                placeholder="First name"
                                [isRequiredLabel]="true"
                                formControlName="firstNameCtrl"
                            ></app-input>
                            <app-input
                                id="input-last-name"
                                label="Last Name"
                                placeholder="Last name"
                                [isRequiredLabel]="true"
                                formControlName="lastNameCtrl"
                            ></app-input>
                        </div>

                        <div class="flex flex-col max-w-4xl pb-4">
                            <div class="flex flex-col gap-4">
                                <app-input
                                    id="input-address"
                                    label="Address"
                                    placeholder="Address"
                                    [isRequiredLabel]="true"
                                    formControlName="addressCtrl"
                                ></app-input>
                                <app-input
                                    id="input-apartment-suite"
                                    label="Apartment/Suite, etc."
                                    placeholder="Apartment, suite, etc"
                                    formControlName="apartmentSuiteCtrl"
                                ></app-input>
                            </div>

                            <app-alert 
                                [alertStyle]="alertStyle.info",
                                [showCloseButton]="false",
                                alertHeaderText="",
                                alertContentText="Please include your business or organisation name if applicable as this may be required for a commercial delivery."
                            ></app-alert>
                        </div>

                        <div class="flex flex-col sm:flex-row gap-4">
                            <app-input
                                id="input-suburb-city"
                                label="Suburb/City"
                                placeholder="Suburb/City"
                                [isRequiredLabel]="true"
                                formControlName="suburbCityCtrl"
                            ></app-input>
                            <app-input
                                id="input-postcode"
                                label="Postcode"
                                placeholder="Postcode"
                                [isRequiredLabel]="true"
                                formControlName="postcodeCtrl"
                            ></app-input>

                        </div>
                        <div class="flex flex-col sm:flex-row gap-4">
                            <app-input
                                id="input-state"
                                label="State"
                                placeholder="State"
                                [isRequiredLabel]="true"
                                formControlName="stateCtrl"
                            ></app-input>
                            <app-input
                                id="input-country"
                                label="Country"
                                placeholder="Country"
                                [isRequiredLabel]="true"
                                formControlName="countryCtrl"
                            ></app-input>
                            
                        </div>
                        <div class="flex flex-col sm:flex-row gap-4">
                            <button 
                                class="btn btn-primary"
                                (click)="submit()"
                                [disabled]="coaForm.invalid || isSubmitting"
                            >Submit
                            </button>
                        </div>
                    </div>
                </form>
            }
        </div>
    }
</div>
